import { objectToSnakeCase, objectToCamelCase } from '../utils'

import api from './api'

export default class Engagement {
  static api = api.create(Engagement)

  constructor({
    id = null,
    title = '',
    photo = null,
    shortDescription = null,
    fullDescription = null,
    secondaryPhotos = [],
  } = {}) {
    Object.assign(this, {
      id,
      title,
      photo,
      shortDescription,
      fullDescription,
      secondaryPhotos,
    })
  }

  copy() {
    return new Engagement(this)
  }

  update(data = {}) {
    return Object.assign(this.copy(), data)
  }

  static create(data = {}) {
    return new Engagement(data)
  }

  static fromAPI(json = {}) {
    return new Engagement(objectToCamelCase(json))
  }

  /**
   *  Prep data for the API.
   **/
  static toAPI(engagement, fields = []) {
    // By default, send the whole engagement
    let data = {}

    // If it's a partial update, get only the fields specified
    if (fields.length > 0) {
      fields.forEach(field => {
        data[field] = engagement[field]
      })
    } else {
      data = engagement
    }

    return objectToSnakeCase(data)
  }

  static checkIsInstance(obj, name) {
    if (!(obj instanceof Engagement)) {
      throw Error(`${name} must be an instance of the Engagement class.`)
    }
  }
}
